/**
 * The /app not-found and render-error pages (mission 6 review follow-up 23,
 * A-6; FR-003, FR-030; register 16).
 *
 * routes.tsx mounts `AppNotFound` as the /app layout's catch-all child and
 * `AppRouteError` as the layout's errorElement, inside AppShell, so an unknown
 * /app URL or a screen that throws keeps the rail, the breadcrumb and the
 * credit chip (FR-004) instead of React Router's default page outside the
 * shell and the gate. Each states what happened in its own h1 and links back
 * to Runs. The thrown error is never rendered or logged here: it may carry a
 * value the reporter uploaded (TEN.11).
 */
import { Link } from 'react-router-dom'

import { APP_HOME } from '@/components/trellis/AuthGate'
import { copyText, type TextKey } from '@/lib/provisional-copy'

function Fallback({ title, body }: { title: TextKey; body: TextKey }) {
  return (
    <div className="flex max-w-2xl flex-col gap-4">
      <h1 className="text-h1 text-navy-950">{copyText(title)}</h1>
      <p className="text-body text-navy-700">{copyText(body)}</p>
      <p>
        <Link to={APP_HOME} className="text-body text-[var(--color-link)] hover:underline">
          {copyText('backToRuns')}
        </Link>
      </p>
    </div>
  )
}

/** An /app URL no route matches. */
export function AppNotFound() {
  return <Fallback title="notFoundTitle" body="notFound" />
}

/**
 * Anything a screen under /app throws while rendering. No /app route has a
 * loader, and the catch-all answers unknown URLs, so the error is never a
 * route-level 404 and is not inspected.
 */
export function AppRouteError() {
  return <Fallback title="renderErrorTitle" body="renderError" />
}
